import React from 'react'
import Plaatjie from '@ubo/plaatjie'
import Img from 'gatsby-image'
import ButtonDefault from 'components/elements/ButtonDefault'
import ButtonSlide from 'components/elements/ButtonSlide'
import parse from 'html-react-parser'
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

const ImgCSS = css`
  position: absolute !important;
  height: 100%;
  pointer-events: none;

  right: 0;
  width: 70%;

  @media screen and (max-width: 991px) {
    width: 100% !important;
    position: relative !important;
    height: 250px;
  }
`

const StyledPlaatjie = styled(Plaatjie)`
  ${ImgCSS};

  overflow: hidden;
  display: inline-block;
  vertical-align: top;

  & picture img {
    width: 100%;
    object-fit: cover;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
  }
`

const StyledImg = styled(Img)`
  ${ImgCSS};
`

const StyledHero = styled.section`
  & img {
    object-position: right !important;
  }

  position: relative;
  z-index: 1;
  height: 592px;

  @media screen and (max-width: 991px) {
    height: unset;
  }
`

const HeroContent = styled(motion.div)`
  background-color: ${(props) => props.theme.color.face.light};
  height: 100%;
  padding: 0 70px 0 0;
  position: relative;

  & strong {
    color: ${({ theme }) => theme.color.face.main};
    margin-top: -25px;
    display: block;
    margin-bottom: 30px;
    font-weight: 800;
  }

  right: 100px;
  border-top-right-radius: 600px;
  border-bottom-right-radius: 600px;

  @media screen and (max-width: 991px) {
    border-radius: 20px;
    padding: 40px 40px 40px 40px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  }

  h1 {
    font-weight: ${(props) => props.theme.font.weight.xl};
    padding-bottom: 20px;

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }
  }

  p {
    font-size: ${(props) => props.theme.font.size.m};
  }
`

const StyledButtonDefault = styled(ButtonDefault)`
  margin-top: 25px;

  @media screen and (max-width: 991px) {
    margin-top: 20px;
  }
`

const StyledButtonSlide = styled(ButtonSlide)`
  margin-top: 25px;

  @media screen and (max-width: 991px) {
    margin-top: 20px;
  }
`

const Line = styled.div`
  min-height: 10px;
  background: ${(props) => props.theme.color.gradient.main};
`

const Container = styled.div`
  height: 100%;

  @media screen and (max-width: 991px) {
    height: unset;
    position: relative;

    top: -60px;
    margin-bottom: -45px;
    padding: 0px 45px 0px 45px;
  }
`

const StyledButtons = styled.div`
  display: flex;
  flex-direction: row;
  
  @media screen and (min-width: 992px) {
    gap: 10px;
  }

  @media screen and (max-width: 991px) {
    flex-direction: column;
    gap: 0;
  }
`

const Row = styled.div``
const HeroContentInner = styled.div``
const ColSpacer = styled.div``

const HeroWithButtons = ({ className, content, id = 'hero-with-buttons' }) => {
  if (!content) return null
  return (
    <StyledHero id={id} className={`${className ? `${className}` : ``}`}>
      {!!content.image?.localFile?.childImageSharp?.fluid ? (
        <StyledImg
          fluid={content.image.localFile.childImageSharp.fluid}
          loading="eager"
          alt=""
        />
      ) : (
        <StyledPlaatjie image={content.image} loading="eager" alt="" />
      )}
      <Container className="container">
        <Row className="row h-100">
          <HeroContent
            animate={{ right: 0 }}
            transition={{ duration: 0.6, type: 'spring', damping: 15 }}
            className="col-lg-7 d-flex justify-content-center align-items-center flex-wrap"
          >
            <HeroContentInner className="pl-lg-5 pr-lg-5">
              <h1>{content?.title}</h1>
              {parse(content.description)}
              <StyledButtons>
                {content.link && (
                  <StyledButtonDefault icon="arrow" to={content.link.url}>
                    {content.link.title}
                  </StyledButtonDefault>
                )}
                {content.link_two && (
                  <StyledButtonSlide
                    icon="arrow"
                    to={content.link_two.url}
                    defaultSize
                  >
                    {content.link_two.title}
                  </StyledButtonSlide>
                )}
              </StyledButtons>
            </HeroContentInner>
          </HeroContent>
          <ColSpacer className="col-lg-5" />
        </Row>
      </Container>
      <Line className="d-lg-block d-none" />
    </StyledHero>
  )
}

export default HeroWithButtons
